// extracted by mini-css-extract-plugin
export default {"card":"KM2KV","button":"SmmXD"};